var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-window-html"},[(_vm.artwork)?_c('div',{staticClass:"info-content-container"},[_c('div',[_c('Card',{ref:"windowHeading",attrs:{"hide-map-link":true,"artwork":_vm.artwork}})],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }